import React from "react";

const PreviewItem = ({ title, item }) => {
  return (
    <>
      {item && item !== "null" && (
        <div>
          <h2 className="text-sm mb-1 capitalize text-[black] font-[500] ">
            {title}
          </h2>
          <p className="text-xs  "> {item}</p>
        </div>
      )}
    </>
  );
};

export default PreviewItem;
